import React from "react";
import Joi from "joi-browser";
import Form from "../common/form/form";
import { getUser, saveUser } from "./../../services/userService";

class UserForm extends Form {
  state = {
    data: {
      id: -1,
      name: "",
      email: "",
      password: "",
      isAdmin: false,
      addInf: ""
    },
    errors: {}
  };

  schema = {
    id: Joi.number(),
    name: Joi.string().required(),
    email: Joi.string().required(),
    password: Joi.string().required(),
    isAdmin: Joi.boolean(),
    addInf: Joi.string().allow("")
  };

  async componentDidMount() {
    const { match, history } = this.props;

    const userId = match.params.id;
    if (userId === "new") return;

    const user = await getUser(userId);
    if (!user) return history.replace("/not-found");

    this.setState({ data: this.mapToViewModel(user) });
  }

  mapToViewModel(user) {
    return {
      id: user.id,
      name: user.name,
      email: user.email,
      password: user.password,
      isAdmin: user.isAdmin,
      addInf: user.addInf
    };
  }

  doSubmit = async () => {
    await saveUser(this.state.data);
    this.props.history.push("/users");
  };

  render() {
    return (
      <div>
        <h2>User</h2>
        <form onSubmit={this.handleSubmit}>
          {this.renderLink("/users", "fa fa-arrow-left", "btn btn-secondary")}
          {this.renderButton("fa fa-save", "btn btn-success m-1")}
          {this.renderInput("name", "Name", true)}
          {this.renderInput("email", "e-mail")}
          {this.renderInput("password", "Password", false, "password")}
          {this.renderCheckBox("isAdmin", "Administrator")}
          {this.renderInput("addInf", "Add. Inf.")}
        </form>
      </div>
    );
  }
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/users/userForm.jsx